<template>
  <section>
    <div class="container">
      <div v-if="fill_info == '' && subpage == 'open'" class="row">
        <div class="col-xs-12">
          <div class="form-title">Kitöltési útmutató</div>
          <PerfectScrollbar :options="{wheelPropagation: false, handlers:['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch']}" style="height: 50vh; border: 1px solid #f4f4f4; padding: 20px 20px 0px 20px; margin-bottom: 20px;">
          <div class="article-text medium">
            <p>Tisztelt Ösztöndíjas!</p>
            <p>Az Új Nemzeti Kiválóság Program (továbbiakban: ÚNKP) keretein belül a Pályázati Kiírásoknak megfelelően minden ösztöndíjas számára kötelező a kutatási időszaka végén a pályázatában vállalt kutatásáról <span class="highlight">Szakmai Záró Beszámoló</span>t (továbbiakban: Beszámoló) és annak részeként <span class="highlight">Témavezetői Szakmai Értékelés</span>t (továbbiakban: Értékelés) benyújtani a megfelelő igazolásokkal együtt.</p>

            <p>A Beszámolót a Széchenyi István Egyetem (továbbiakban: Egyetem) ÚNKP bíráló bizottsága fogja értékelni Kiváló, Megfelelt és Nem megfelelt minősítéssel.</p>

            <p>Amennyiben az Egyetem a Beszámolót nem fogadja el, Nem megfeleltre értékeli, vagy az ösztöndíjas nem nyújtja be azt a megadott határidőig, az Egyetem az ösztöndíjas számára visszafizetési kötelezettséget állapít meg.</p>

            <p>Minden esetben a <span class="highlight"><u>KTR felületen kérjük véglegesíteni a Beszámolót</u></span>. Ezt követően az ÚNKP felelősök ellenőrzik az anyagot, és esetlegesen hiánypótlási felhívást intéznek az Ösztöndíjas felé. A hiánypótlás csak papíralapon lehetséges. <span class="highlight"><u>Akár szükséges hiánypótlás, akár nem, a teljes anyag papíralapú leadása egy előzetes, emailen történő időpontegyeztetés után az Igazgatási Épület (SZE Győr) 512-es irodájában történik, ahol az <i>eredeti</i>, aláírt Beszámolót, Értékelést, Konzultációs lapot, és a Beszámolóhoz tartozó összes <i>mellékletet</i></u></span> kérjük benyújtani.</p>

            <p>A <span class="highlight"><u>mellékletek tetejére minden esetben kérjük ráírni a melléklet számát és az elnevezését</u></span>. Amennyiben a mellékletek <span class="highlight"><u>másolati példányok, kérjük ráírni, hogy „Az eredetivel mindenben megegyező hiteles másolat.” és aláírni azt</u></span>.</p>

            <p>A <span class="highlight"><u>Kutatási Terv</u></span> a beadott pályázati anyag részét képezi. A Beszámolóhoz elegendő egy másolati példány benyújtása, ami a pályázati felhívás kapcsán már a folyamat elején is feltöltésre került a KTR rendszerbe.</p>

            <p><span class="highlight">Kitöltési segédlet a KTR felülethez:</span></p>
            <ul class="ordered-list with-icon" style="padding-bottom: 20px;">
              <li><i class="fa fa-angle-right"></i>A <u>Záró Beszámolók közül</u> a vonatkozó ösztöndíjas kategória szerinti sablont kérjük kiválasztani.</li>
              <li><i class="fa fa-angle-right"></i>A <u>Témavezetői Értékelést</u> – a fejlécet kitöltve – kérjük eljuttatni a témavezetőhöz, majd a Beszámoló részeként, kitöltve kérjük <span class="highlight">feltölteni a KTR rendszerbe mind szerkeszthető mind pdf formában</span>.</li>
              <li><i class="fa fa-angle-right"></i>Az <span class="highlight"><u>1-5 pontot</u></span> kérjük <span class="highlight"><u>röviden</u></span> kifejteni, de a <span class="highlight"><u>Beszámoló teljes terjedelme ne legyen több 3 oldalnál</u></span>.</li>
              <li><i class="fa fa-angle-right"></i>A <span class="highlight"><u>2/a. pontnál</u></span> kérjük leírni, hogy az ÚNKP intézményi keret terhére történt-e egyéni keretfelhasználás.
              <br>-	Ha nem történt beszerzés, akkor kérjük, ne kerüljön semmi sem a 2/a. ponthoz.
              <br>-	Ha történt beszerzés, kérjük megadni milyen jellegű volt, hogyan került felhasználásra az ÚNKP kutatás során (1-1 mondat) a beszerzett tétel, illetve beszerzésnél az anyagok/eszközök egyetemi leltárba kerültek-e vagy fogyóeszköznek minősültek.
              <br><br><i>Példák 2/a ponthoz:</i>
              <br>- Könyvbeszerzés: pl.: Saltelli, A, Chan, K., Scott, E. M.: Sensitivity Analysis, 2008, John Wiley & Sons Ltd. – kutatásom során fontos szakirodalom, egyetemi leltárba került
              <br>- Konferenciarészvétel: 15th Miklós Iványi International Phd&Dla Symposium, Pécs, 28-29.10.2019. – szabadon választott vállalás
              <br>- Eszközbeszerzés: HDD 2,5" Portable 2TB USB3.1 külső merevlemez - kutatásom során a feldolgozott szakirodalmat és az elkészített szimulációkat tároltam rajta, egyetemi leltárba került
              <br>- Anyagbeszerzés: csillag villáskulcs plusz egyéb laboratóriumi eszközök, melyek fogyóeszköznek minősülnek.
              </li>
              <li><i class="fa fa-angle-right"></i><span class="highlight"><u>A 3. ponthoz</u></span> kerüljenek a beszámolóba a már benyújtott, de még el nem fogadott kéziratok is, amiket számszerűen a 7. pontnál kérünk feltüntetni.</li>
              <li><i class="fa fa-angle-right"></i>A <span class="highlight"><u>6. pontban</u></span> az intézményen belüli kötelező vállalásokhoz szükséges nyilatkozatok szerepelnek. Kérjük, <span class="highlight">ne javítsa a sablon szövegét</span>, és a 2024. június 30., valamint a 2024. augusztus 31-ig tartó ösztöndíjas jogviszony esetén legyen kedves aláhúzni, hogy melyik napon tartott előadást az ÚNKP konferencián.</li>
              <li><i class="fa fa-angle-right"></i><u>7. pontnál</u> <span class="highlight">minden cella kitöltése szükséges, a 0-ákat is feltüntetve</span>.</li>
              <li><i class="fa fa-angle-right"></i>A <u>Mellékletek</u>: <span class="highlight">Elnevezésük</span> minden esetben a következő legyen: melléklet száma, elnevezése, ösztöndíjas saját neve. Pl.: 1.sz. melléklet Kutatási Terv Gipsz Jakab</li>
              <li><i class="fa fa-angle-right"></i>A <span class="highlight">Beszámoló 1-5. pontjainál</span> is kérjük feltüntetni a hozzá tartozó melléklet <u>számát</u>.</li>
              <li><i class="fa fa-angle-right"></i>A kötelező mellékletek után <span class="highlight">folytatólagosan szükséges számozni a további mellékleteket is</span> (szakirodalom feldolgozások, megjelent, elfogadott cikkek, konferenciaelőadások, TDK dolgozat, MTMT lista, stb.). A <span class="highlight">papíralapú nyomtatásnál lehet kicsinyítve</span> (1 lapon 2 oldal jelenjen meg) <span class="highlight">2 oldalasan nyomtatni a hosszabb</span> cikkeket, előadásokat.</li>
              <li><i class="fa fa-angle-right"></i>A 6. ponthoz nem szükséges mellékelni semmit sem, ezt központilag az Intézményi Beszámolóban fogjuk igazolni.</li>
              <li><i class="fa fa-angle-right"></i>A <span class="highlight">KTR-be az eredeti dokumentumok szkennelt másolatát kérjük</span> feltölteni.</li>
              <li><i class="fa fa-angle-right"></i><span class="highlight">Papír alapú leadáskor</span> az oklevelek, igazolások másolati példányaira kérjük ráírni, hogy „Az eredetivel mindenben megegyező hiteles másolat.”, és számozott mellékletként kérjük ezeket is csatolni a beszámolóhoz.</li>
            </ul>
            <p>Köszönettel és üdvözlettel,<br>ÚNKP felelős</p>
          </div>
          </PerfectScrollbar>
          <button @click="subpage = 'data'" type="button" class="button">Tovább</button>
        </div>
      </div>
      <div v-if="fill_info == '' && subpage == 'data'" class="row">
        <div class="col-xs-12">
          <div class="form-title">Adatok</div>
        </div>
        <div class="col-sm-6">
          <inputbox id="nev" label="Viselt neve <span style='font-size: 10px; display: block; font-weight: 400'>(A dr-i, egyéb nevére vonatkozó előtagokat, a neve után vesszővel elválasztva tüntesse fel)</span>" name="nev" regexp_filter="[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+" v-model="form.nev" :errors="errors"/>
        </div>
        <div class="col-sm-6">
          <inputbox id="email" label="E-mail cím <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>" name="email" v-model="form.email" :errors="errors"/>
        </div>
        <div class="clearfix"></div>
        <div class="col-sm-6">
          <inputbox id="mobilszam" label="Mobilszám" mask="+99 99 / 999 9999" regexp_filter="[0-9]+" name="mobilszam" v-model="form.mobilszam" :errors="errors"/>
        </div>
        <div class="clearfix"></div>

        <div class="col-xs-12">
          <div class="info-box download" style="margin-bottom: 5px;">
            <a target="_blank" href="assets/files/szakmai-zaro-beszamolo-sablon-23-10.docx" title="Szakmai záró beszámoló sablon letöltés">
              <span class="highlight">Szakmai záró beszámoló sablon</span> letöltés
            </a>
          </div>
          <div class="info-box download">
            <a target="_blank" href="assets/files/temavezetoi-szakmai-ertekeles-23-10.docx" title="Témavezetői szakmai értékelés sablon letöltés">
              <span class="highlight">Témavezetői szakmai értékelés sablon</span> letöltés
            </a>
          </div>
        </div>

        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.szakmai_zaro_beszamolo_szerkesztheto = value; }" accepted_files="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :errors="errors" id="szakmai_zaro_beszamolo_szerkesztheto" label="Szakmai Záró Beszámoló szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Záró Szakmai Beszámoló_szerk. legyen.)</span>" name="szakmai_zaro_beszamolo_szerkesztheto" :loaded_files="form.szakmai_zaro_beszamolo_szerkesztheto"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.szakmai_zaro_beszamolo = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="szakmai_zaro_beszamolo" label="Szakmai Záró Beszámoló aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Záró Szakmai Beszámoló legyen.)</span>" name="szakmai_zaro_beszamolo" :loaded_files="form.szakmai_zaro_beszamolo"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.temavezetoi_szakmai_ertekeles_szerkesztheto = value; }" accepted_files="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" :errors="errors" id="temavezetoi_szakmai_ertekeles_szerkesztheto" label="Témavezetői Szakmai Értékelés szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Témavezetői Szakmai Értékelés_szerk. legyen.)</span>" name="temavezetoi_szakmai_ertekeles_szerkesztheto" :loaded_files="form.temavezetoi_szakmai_ertekeles_szerkesztheto"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.temavezetoi_szakmai_ertekeles = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="temavezetoi_szakmai_ertekeles" label="Témavezetői Szakmai Értékelés aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Témavezetői Szakmai Értékelés legyen.)</span>" name="temavezetoi_szakmai_ertekeles" :loaded_files="form.temavezetoi_szakmai_ertekeles"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.konzultacios_lap = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="konzultacios_lap" label="Konzultációs lap aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Konzultációs lap legyen.)</span>" name="konzultacios_lap" :loaded_files="form.konzultacios_lap"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="1" @change="(value) => { form.kutatasi_terv = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="kutatasi_terv" label="Kutatási terv aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A pályázat beadásakor (alapképzés esetén szeptemberben) leadott eredeti, aláírt Kutatási Terv), (A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Kutatási terv legyen.)</span>" name="kutatasi_terv" :loaded_files="form.kutatasi_terv"/>
        </div>
        <div class="col-xs-12">
          <UploadHandler max_uploaded_files="10" @change="(value) => { form.mellekletek = value; }" accepted_files="image/jpeg,application/pdf,application/x-pdf" :errors="errors" id="mellekletek" label="Mellékletek <span style='font-size: 10px; display: block; font-weight: 400'>(A melléklet elnevezése, száma a Szakmai Záró Beszámoló pontjai szerint. Doktori hallgatói-, doktorjelölt kategóriánál az MTMT lista kötelező melléklet. A 6. pont teljesítését központilag az Intézményi Szakmai Beszámolóban fogjuk igazolni.)</span>" name="mellekletek" :loaded_files="form.mellekletek"/>
        </div>

        <div class="col-xs-12">
          <div v-for="(url, i) in form.melleklet_urlek" style="display: flex; align-items: center; margin-bottom: 5px;">
            <input type="text" placeholder="Külső Url (pl.: http://webcim.hu/dokumentum.pdf)" class="form-control" v-model="form.melleklet_urlek[i]"/>
            <a :href="form.melleklet_urlek[i]" target="_blank" style="margin-left: 5px;" class="button only-icon v2">
              <i class="fa fa-eye"></i>
            </a>
            <button @click="deleteUrl(i)" style="margin-left: 5px;" type="button" class="button only-icon">
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
          <div style="display: flex; align-items: center; margin-bottom: 20px;">
            <input type="text" placeholder="Külső Url (pl.: http://webcim.hu/dokumentum.pdf)" class="form-control" v-model="uj_melleklet_url">
            <button @click="addUrl" style="margin-left: 5px;" type="button" class="button only-icon v2">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>

        <div class="col-xs-12">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <button v-on:click="save(1)" :disabled="saving" type="button" class="button">Mentés</button>
            <button v-on:click="save(2)" :disabled="saving" type="button" class="button">Véglegesít</button>
          </div>
        </div>
      </div>
      <div v-if="fill_info != ''" class="row">
        <div class="col-xs-12">
          <div class="form-title">ÚNKP Szakmai Záró Beszámoló</div>
          <div v-html="fill_info"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

export default {
  components: {
    PerfectScrollbar
  },
  data: function() {
    return {
      saving: false,
      errors: [],
      fill_info: '',
      subpage: 'open',
      uj_melleklet_url: '',
      form: {
        tipus: 14,
        nev: '',
        email: '',
        mobilszam: '',
        szakmai_zaro_beszamolo_szerkesztheto: [],
        szakmai_zaro_beszamolo: [],
        temavezetoi_szakmai_ertekeles_szerkesztheto: [],
        temavezetoi_szakmai_ertekeles: [],
        konzultacios_lap: [],
        kutatasi_terv: [],
        mellekletek: [],
        melleklet_urlek: []
      }
    }
  },

  computed: {
  },

  watch: {
  },

  mounted: function() {
    var _this = this;

  	Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);
      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });

    this.$root.ajax('form/unkp_beszamolo_ell/' + this.form.tipus, {
      success: function(response) {
        if (response.error != false) {
          _this.fill_info = response.error;
          return;
        }

        if (response.form != undefined) {
          _this.form = response.form;
        }
      }
    });
  },

  methods: {
    deleteUrl: function(i) {
      this.form.melleklet_urlek.splice(i, 1);
    },

    addUrl: function() {
      if (this.uj_melleklet_url != '') {
        this.form.melleklet_urlek.push(this.uj_melleklet_url);
        this.uj_melleklet_url = '';
      }
    },

    save: function(veglegesit) {
      var _this = this;

      this.saving = true;
      this.errors = [];

      if (this.uj_melleklet_url != '') {
        swal('Figyelem!', 'A melléklet url-jét "+" jellel adja hozzá a listához.', 'error');
        this.saving = false;
        return;
      }

      this.$root.ajax('form/unkp_beszamolo_ment', {
        method: 'POST',
        data: {
          form: JSON.stringify(this.form),
          veglegesit: veglegesit
        },
        success: function(response) {
          _this.saving = false;

          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = veglegesit == 1 ? 'Ön elmentette az űrlap kitöltését. Befogadáshoz Önnek véglegesítenie kell a kitöltését. Az űrlap megtekintéséhez kattintson az alábbi <a href="javascript:void(0)" onclick="location.reload()">linkre.</a>' : 'Köszönjük, Ön sikeresen véglegesítette az űrlap kitöltését.';
          }
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// unkp_beszamolo_23_10.vue?216d8787